import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    isLoading: false,
    theme: "dark",
    heading: "",
    isFormLoading: false,
    breadcrumb: [],
    badlaOptions: [],
    liveMarketPersist: [],
  },
  reducers: {
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setTheme(state, action) {
      state.theme = action.payload;
    },
    setHeading(state, action) {
      state.heading = action.payload;
    },
    setFormSubmitLoading(state, action) {
      state.isFormLoading = action.payload;
    },
    addBreadcrumb(state, action) {
      state.breadcrumb = action.payload;
    },
    setBadlaOptions(state, action) {
      state.badlaOptions = action.payload;
    },
    setLiveMarket(state, action) {
      state.liveMarketPersist = action.payload;
    },
    clearUI(state, action) {
      state.isLoading = false;
      state.theme = "dark";
      state.heading = "";
      state.isFormLoading = false;
      state.breadcrumb = [];
      state.badlaOptions = [];
    },
  },
});

export const uiActions = uiSlice.actions;
export default uiSlice;
